import * as React from 'react'
import $ from 'jquery'
import { DropdownMenu, DropdownItem, Row, Col } from 'reactstrap'

import { update, queryNoTracking, deleteEntity, addEntity, clearEntities, saveEntities, queryTracking, isDirtyEntity } from './../services/DataService'
import { accentUtils, from, formHelper, showOK, goTo, t, showDialog, ConvertDateFromUTC, ConvertDateToUTC, showWait } from './../services/HelperService'
import * as ActivityService from './../services/ActivityService'
import { ActivityStatus } from './../services/ActivityService'
import * as JobService from './../services/JobService'
import { getAccess, getUser } from './../services/UserService'
import { showWizard } from './../wizards/RTLWizard'
import NewServiceJobWizard from './../wizards/NewServiceJobWizard'
import LinkOpportunityWizard from './../wizards/LinkOpportunityWizard'

import AccentIcons from './../icons/Icons'
import { AccentButton } from './../controls/AccentButton'
import { onSelectAddCompany, onSelectAddContact } from './../controls/helpers/CompanyContactHelper'
import { AccentDropdownButton } from './../controls/AccentDropdownButton'
import { AccentFormCtrlNoViewState, useValidation } from './../controls/bound/AccentFormCtrl'
import { AccentCheckUnbound } from '../controls/unbound/AccentCheckUnbound';
import { UserTeamSelectCtrl } from './../controls/UserTeamSelectCtrl'
import { AccentDisplay, isMobileOnly, useAccentDisplay } from './../controls/AccentDisplay'
import { AccentAddress } from './../controls/bound/AccentAddress'
import { ActivityJobCtrl, ActivityJobLineCtrl } from './../controls/activities/ActivityJobLineCtrl'
import { ContactInfoCtrl } from '../controls/contacts/ContactInfoCtrl'
import { AccentDialog } from './AccentDialog'
import { ActivityInstallerViewCtrl } from '../controls/activities/ActivityInstallerViewCtrl'
import { shiftEndWithStartChange } from '../controls/calendar/EventSchedulingSection'
import { contextSources, getContext, getContextData, setContext } from '../services/EntityContextService'
import { ActivitySummaryIcon } from './ActivitySummaryDlg'
import { ActivityOutcomeCtrl } from '../controls/activities/ActivityOutcomeCtrl'
import { FileNoteAlert } from '../controls/FileNoteCtrl'
import { showAuditLog } from '../app-framework/AuditLogDlg'
import { showActivityCancel } from './ActivityCancelDlg'
import { RTLReadOnlyBar } from '../controls/RTLReadOnlyBar'
const MobileCalendarDlg = React.lazy(() => import('./MobileCalendarDlg'));


const query_AddressForCompany = queryNoTracking("AddressForCompanyID");
const query_AddressForContact = queryNoTracking("AddressForContactID");
const query_ActivityCategories = queryNoTracking("PL_ActivityCategories");
const query_CustomerAvailability = queryNoTracking("PL_CustomerAvailabilities");
const query_Opportunity_SelectList = queryNoTracking("Opportunity_SelectList");
const query_ActivityAttendee_SelectList = queryNoTracking("ActivityAttendee_SelectList", null, true);
const query_ActivityView_ContactSelectList = queryNoTracking("ActivityView_ContactSelectList");
const query_Company_SelectList = queryNoTracking("Company_SelectList");
const query_Opportunity_GetForActivityCancel = queryNoTracking("Opportunity_GetForActivityCancel");
const query_Activity_View = queryTracking("Activity_View");




export const showActivity = (args) => {

    return showDialog(<ActivityDlg activityID={args.activityID} timeZone={ args.timeZone}
        onNew={function (e) {

            if (!accentUtils.isNull(args.representativeID)) {
                e.RepresentativeID = args.representativeID
            }

            if (!accentUtils.isNull(args.start)) {
                e.Start = new Date(args.start);
            }

            if (!accentUtils.isNull(args.end)) {
                e.End = new Date(args.end);
            }

            if (args.defaults) {

                Object.keys(args.defaults).map(k => e[k] = args.defaults[k]);

            }

            if (args.onNew) {
                args.onNew(e);
            }

            //if (!accentUtils.isNull(me.scheduleJobModel)) {
            //    if (!accentUtils.isNull(me.scheduleJobModel.onSheduleJob)) {
            //        me.scheduleJobModel.onSheduleJob(e);
            //    }
            //}


        }}
    />);
}


const activityCanHaveJob = (entity) => {

    return !accentUtils.isNull(entity.JobID) || !accentUtils.isNull(entity.OpportunityID) ||
        ActivityService.Helper.activityTypeCanHaveJob(entity.ActivityType);
};

const activityRequireJob = (act) => (act.ActivityType === ActivityService.Helper.typeCheckMeasure || act.ActivityType === ActivityService.Helper.typeInstall);

const getCancelledReasonText = (entity) => entity.CancelledReasonDescription ?? "";

const UncancelActivityDlg = React.memo(({ onClose }) => {
    const [reopenOpportunity, setReopenOpportunity] = React.useState(true);

    return (
        <AccentDialog
            headerContent={t("application_strings.application.dialogs.uncancelActivityTitle")}
            onClose={onClose}
            cancelLabel={"application_strings.application.buttons.cancel"}
            maxWidth={600}
            actionsContent={[
                <AccentButton key="confirm" onClick={() => onClose({ canceled: false, reopenOpportunity })}>
                    {t("application_strings.application.buttons.open")}
                </AccentButton>
            ]}
        >
            <div className="d-flex flex-column gap-2">
                <div>{t("application_strings.application.dialogs.uncancelActivityMsg")}</div>
                <AccentCheckUnbound
                    defaultValue={reopenOpportunity}
                    label="Reopen linked opportunity"
                    onChange={e => setReopenOpportunity(e.checked)}
                    style={{ padding: "10px 0" }}
                />
            </div>
        </AccentDialog>
    );
});

export const ActivityDlg = React.memo(React.forwardRef((props, ref) => {

    const cboContact = React.createRef();
    const cboCompany = React.createRef();
    const ctrlAttendees = React.createRef();
    const siteAddressCtrl = React.createRef();
    const [attendeeReadOnly, setAttendeeReadOnly] = React.useState(false);
    const [isDirty, setIsDirty] = React.useState(false);
    const [forceUpdateKey, setForceUpdateKey] = React.useState(1);
    const [forceUpdateDatesKey, setForceUpdateDatesKey] = React.useState(1);
    const [viewModel, setViewModel] = React.useState(null);
    const [ownerChanged, setOwnerChanged] = React.useState(null);
    const [showInstallSummary, setShowInstallSummary] = React.useState(false);
    const [addressRequired, setAddressRequired] = React.useState(false);
    const [canHaveJob, setCanHaveJob] = React.useState(false);
    const lastJobIDRef = React.useRef(null);




    const [printSettings, setPrintSettings] = React.useState(null);
    const [productsChanged, setProductsChanged] = React.useState(false);
    const [allProducts, setAllProducts] = React.useState([]);
    const [reloadProducts, setReloadProducts] = React.useState(0);


    const display = useAccentDisplay();
    const validation = useValidation("div[aria-labelledby='accentCalendarDlg']");


    const user = getUser();

    const tagDataAsObj = (act, merge) => {

        var tag = accentUtils.isEmpty(act.TagData) ? {} : JSON.parse(accentUtils.isEmpty(act.TagData));

        return { ...tag, ...merge };

    };


    const showRunDlg = async (e) => {
        await showDialog(<MobileCalendarDlg startDate={ viewModel.entity.Start } />);
        e?.promise();
    };
    

    const doSave = React.useCallback((forceSave) => {

        return new Promise(p => {

            if ((forceSave ?? false) || formHelper.isDlgValid()) {

                beforeActivitySave(viewModel).then(allowSave => {

                    if (allowSave) {

                        const attendeesToDelete = from(viewModel.entity.Attendees).where(at => viewModel.entity.AttendeeList.indexOf(at.RepID) == -1).toArray();
                        const attendeesToAdd = from(viewModel.entity.AttendeeList).where(i => !from(viewModel.entity.Attendees).any(at => at.RepID == i)).toArray();

                        attendeesToDelete.map(a => {
                            deleteEntity(a);
                        });


                        if (!getShowContactDetails() && viewModel.entity.JobLines && viewModel.entity.JobLines.length != 0) {

                            viewModel.entity.JobLines.map(l => {
                                deleteEntity(l);
                            });


                        }

                        var createdAttendees = attendeesToAdd.map(repID => {
                            return addEntity(
                                "ActivityRep", {
                                RepID: repID,
                                ActivityID: viewModel.entity.ID
                            });
                        });


                        Promise.all(createdAttendees).then(ats => {

                            if (!accentUtils.isNullOrEmpty(viewModel.timeZone)) {
                                viewModel.entity.Start = ConvertDateToUTC(viewModel.entity.Start, viewModel.timeZone);
                                viewModel.entity.End = ConvertDateToUTC(viewModel.entity.End, viewModel.timeZone);
                            }

                            saveEntities().then(s => {
                                clearEntities();
                                p(true);
                                return;
                            }).catch(function (err) {

                                var msg = "";

                                if (accentUtils.isNull(err)) {
                                    msg = "Unknown error occurred saving data. please try again";
                                } else {

                                    if (err.entityErrors) {
                                        if (err.entityErrors.length > 0) {
                                            msg = err.entityErrors[0].errorMessage;
                                        }
                                    } else {
                                        if (err.message)
                                            msg = err.message;
                                        else
                                            msg = err;
                                    }
                                }

                                showOK("application_strings.application.dialogs.viewValidationTitle", t(msg), ["application_strings.application.buttons.close"], false, null, true);
                                p(false);
                                return;
                            });

                        });


                    } else {
                        p(false);
                    }
                });
            } else {
                p(false);
            }
        });
    }, [props, viewModel, isDirty]);


    const newServiceJob = React.useCallback((e) => {

        if (JobService.Helper.allowCreateServiceJob()) {

            if (!accentUtils.isNull(viewModel.entity.JobID)) {
                showWizard(NewServiceJobWizard, true, { context: { id: viewModel.entity.JobID, type: "Job" } });
            } else {

                getContextData(getContext()).then(ctx => {
                    NewServiceJobWizard.CreateNewServiceJob(ctx);
                });

                
            }

        }


    }, [props, doSave, viewModel]);

    const newQuote = React.useCallback((e) => {

        doSave().then(saved => {

            if (saved) {
                ActivityService.Helper.createNewQuote(viewModel.entity.ID, viewModel.entity.RepresentativeID).then(created => {

                    if (created) {
                        // close dialog
                        props.onClose({
                            canceled: false,
                            saved: true,
                            changed: false,
                            activity: viewModel.entity
                        });
                    }

                });

                
            } else {
            }


        })



    }, [props, doSave, viewModel]);

    const onBeforePrint = React.useCallback((e) => {

        return new Promise(p => {
            doSave().then(saved => {

                if (saved) {
                    p();
                } else {
                    p({ canceled: true });
                }

            });
        });


    }, [doSave]);

    const startCM = React.useCallback((e) => {


        const productsValid = $(".acc-sel-tag.accentInvalidCtrl").length == 0;

        if (productsValid) {

            ActivityService.Helper.startCM(viewModel.entity.ID, viewModel.entity.JobID);

        } else {
            showOK("application_strings.application.dialogs.activityInvalidProductsTitle", "application_strings.application.dialogs.activityInvalidProductsMsg", ["application_strings.application.buttons.ok"]);
        }

    }, [props, ownerChanged, viewModel, doSave]);

    const setLive = React.useCallback(async (e) => {

        try {
            await update("ToggleAppointmentPlanning", { ID: viewModel.entity.ID }, true);

            // optimistic update inside the dialog
            viewModel.entity.IsPlanning = false;


            setForceUpdateKey(k => k + 1);
        } catch (ex) {
            // silent fail
        }

        e?.promise?.();
    }, [viewModel, setForceUpdateKey]);

    const closeActivity = React.useCallback((e) => {



        var doClose = () => {

            viewModel.entity.Closed = true;
            doSave().then(function (saved) {
                if (saved) {
                    // close dialog
                    props.onClose({
                        canceled: false,
                        saved: true,
                        changed: true,
                        activity: viewModel.entity
                    });
                }
            });
        };


        if (viewModel.entity.ActivityType === ActivityService.Helper.typeCheckMeasure) {
            JobService.Helper.showByPassCMWarning().then(byPass => {
                if (byPass) {

                    JobService.Helper.byPassCMForActivities([viewModel.entity.ID]).then(r => {

                        if (r.InProgressSkipped > 0) {

                            showOK("application_strings.application.dialogs.completeCMInprogressTitle", "application_strings.application.dialogs.completeCMInprogressMsg", ["application_strings.application.buttons.ok"]);


                        } else {
                            props.onClose({
                                canceled: false,
                                saved: true,
                                changed: true,
                                activity: viewModel.entity
                            });


                        }
                    });

                }
            });
        } else if (viewModel.entity.ActivityType === ActivityService.Helper.typeInstall) {

            update("Activity_HasPendingCMLine", { IDs: [viewModel.entity.ID] }).then(r => {

                if (r.HasPendingCM) {

                    showOK("application_strings.application.dialogs.installHasCMPendingTitle", "application_strings.application.dialogs.installHasCMPendingMsg", ["application_strings.application.buttons.ok"]);

                } else {

                    if (viewModel.entity.Processed === true || accentUtils.isEmpty(viewModel.entity.JobLines) || !getAccess().modules().RTL_Service()) {
                        doClose();
                    } else {

                        goTo(`/InstallCompletionForm/${viewModel.entity.JobID}?activity=${viewModel.entity.ID}`);

                   
                    }

                }


            });


        } else {
            doClose();
        }



    }, [props, ownerChanged, viewModel, doSave]);

    const openActivity = React.useCallback((e) => {


        showOK("application_strings.application.dialogs.reOpenActivityTitle", "application_strings.application.dialogs.reOpenActivityMsg", ["application_strings.application.buttons.open"], false, null, false, 600)
            .then(function (res) {
                if (res === "application_strings.application.buttons.open") {
                    viewModel.entity.Closed = false;
                    doSave(true).then(function (saved) {
                        if (saved) {
                            // close dialog
                            props.onClose({
                                canceled: false,
                                saved: true,
                                changed: true,
                                activity: viewModel.entity
                            });
                        }
                    });
                } else {
                }
            });

    }, [props, viewModel, doSave]);

    const uncancelActivity = React.useCallback(async (e) => {
        let reopenOpportunity = false;
        let openConfirmed = false;

        if (!accentUtils.isEmpty(viewModel.entity.OpportunityID)) {
            let opp = null;
            const done = showWait();
            try {
                opp = await query_Opportunity_GetForActivityCancel.getFirstOrDefault({ id: viewModel.entity.OpportunityID });
            } finally {
                await done();
            }

            if (opp?.IsLost === true) {
                const dlgRes = await showDialog(<UncancelActivityDlg />);
                if (dlgRes?.canceled) return;

                openConfirmed = true;
                reopenOpportunity = dlgRes?.reopenOpportunity === true;
            }
        }

        if (!openConfirmed) {
            const res = await showOK("application_strings.application.dialogs.uncancelActivityTitle", "application_strings.application.dialogs.uncancelActivityMsg", ["application_strings.application.buttons.open"], false, null, false, 600);
            if (res !== "application_strings.application.buttons.open") return;
        }

        update("Calendar_UncancelActivity", { ID: viewModel.entity.ID, ReopenOpportunity: reopenOpportunity }).then(() => {
            viewModel.entity.Cancelled = false;
            viewModel.entity.Status = (viewModel.entity.Closed ? ActivityStatus.Closed : ActivityStatus.Open);
            viewModel.entity.PL_ActivityCancelReasonID = null;
            viewModel.entity.CancelledBy = null;
            viewModel.entity.CancelledNotes = null;
            viewModel.entity.CancelledReasonDescription = null;
            props.onClose({
                canceled: false,
                saved: true,
                changed: true,
                activity: viewModel.entity,
                activityUpdateContext: {
                    action: "uncancel",
                    opportunityID: viewModel.entity.OpportunityID,
                    activityType: viewModel.entity.ActivityType
                }
            });
        });
    }, [props, viewModel]);

    const cancelActivity = React.useCallback((e) => {
        showActivityCancel(viewModel.entity).then(result => {
            if (result) {
                viewModel.entity.Cancelled = true;
                viewModel.entity.Status = ActivityStatus.Cancelled;
                viewModel.entity.PL_ActivityCancelReasonID = result.PL_ActivityCancelReasonID;
                viewModel.entity.CancelledNotes = result.CancelledNotes || null;
                props.onClose({
                    canceled: false,
                    saved: true,
                    changed: true,
                    activity: viewModel.entity,
                    activityUpdateContext: {
                        action: "cancel",
                        opportunityLost: result.OpportunityLost === true,
                        opportunityID: result.OpportunityID ?? viewModel.entity.OpportunityID,
                        activityType: viewModel.entity.ActivityType
                    }
                });
            }
        });
    }, [props, viewModel]);


    const showHistory = React.useCallback((type) => {

        if (type === 2) {
            showAuditLog({ entityType: "ActivityRep", id: viewModel.entity.ID, isParentID: true });
            return;
        }
        if (type === 3) {
            showAuditLog({ entityType: "ActivityJobLine", id: viewModel.entity.ID, isParentID: true });
            return;
        }

        showAuditLog({ entityType: "Activity", id: viewModel.entity.ID });
    }, [viewModel]);


    const saveActivity = React.useCallback((e, showInCalendar) => {

        const wasDirty = isDirty || isDirtyEntity(viewModel.entity);

        doSave().then(saved => {
            if (saved) {

                e.promise();
                props.onClose({
                    canceled: false,
                    saved: true,
                    changed: wasDirty,
                    activity: viewModel.entity,
                    showInCalendar: showInCalendar
                });

                if (showInCalendar) {
                    ActivityService.Helper.showInCalendar(viewModel.entity.ID);
                }





            } else {
                e.promise();
            }
        });
    }, [props, viewModel, isDirty, doSave]);
    const cancelDlg = React.useCallback((e) => {
        clearEntities();

        props.onClose({
            canceled: true
        });
    }, [props]);


    const confirmAppointmentInPast = (act) => {

        const isDispatchType = act.ActivityType === ActivityService.Helper.typeInstall
            || act.ActivityType === ActivityService.Helper.typeCheckMeasure;

        if (!isDispatchType) return Promise.resolve(true);

        const startDate = act.Start ? new Date(act.Start) : null;
        if (!startDate || startDate >= new Date()) return Promise.resolve(true);

        // Only prompt when the user actually picked / changed the start time. Saving an
        // unrelated edit on an already-past appointment shouldn't nag.
        const startChanged = !accentUtils.isNull(act.entityAspect?.originalValues?.Start);
        const isNew = act.entityAspect?.entityState?.isAdded?.() === true;
        if (!startChanged && !isNew) return Promise.resolve(true);

        const continueLabel = "Save Anyway";

        return showOK(
            "Appointment is in the past",
            "The selected start time is in the past. Save this appointment anyway?",
            [continueLabel],
            false,
            null,
            false,
            600
        ).then(res => res === continueLabel);
    };

    const beforeActivitySave = (e) => {

        const act = e.entity;

        return new Promise(function (p) {

            const resolveWithPastCheck = () => {
                confirmAppointmentInPast(act).then(p);
            };

            if ((act.ActivityType === ActivityService.Helper.typeSales || act.ActivityType === ActivityService.Helper.typeShowroomQuote) && accentUtils.isNull(act.OpportunityID)) {
                showWizard(LinkOpportunityWizard, true, { contactID: act.ContactID, isShowroom: act.ActivityType === ActivityService.Helper.typeShowroomQuote }, true).then(function (res) {

                    if (accentUtils.isNull(res)) {
                        p(false);
                    } else {

                        var tag = tagDataAsObj(act, res);
                        if (!accentUtils.isNull(tag.OpportunityID)) {
                            act.OpportunityID = tag.OpportunityID;
                        }
                        act.TagData = JSON.stringify(tag);


                        resolveWithPastCheck();
                    }
                });
            } else {
                resolveWithPastCheck();
            }
        });
    };

    const onOwnerChanged = React.useCallback((e) => {

        var att = from(viewModel.entity.AttendeeList)
            .select(v => Number(v))
            .where(v => accentUtils.isNull(e.previous) || v !== e.previous)
            .toArray();

        if (att.length == 1) {
            ctrlAttendees.current.getFormControl().clearData();
        }


        if (!from(att).any(a => a === viewModel.entity.RepresentativeID)) {
            att.push(Number(viewModel.entity.RepresentativeID));
        }

        const hasOwner = !accentUtils.isEmpty(viewModel.entity.RepresentativeID);

        viewModel.entity.AttendeeList = !hasOwner ? [] : att;

        ctrlAttendees.current.getFormControl().refresh();

        setOwnerChanged(true);
        setAttendeeReadOnly(!hasOwner);
    }, [viewModel, ctrlAttendees, setOwnerChanged, setAttendeeReadOnly]);


    const onAttendeeChanged = React.useCallback((e) => {

    }, [viewModel, ctrlAttendees, setOwnerChanged]);

    const onContactDataReceived = React.useCallback((e) => {
        var currContactID = viewModel.entity.ContactID;

        if (!accentUtils.isNull(currContactID)) {
            if (!accentUtils.isNull(e.data)) {
                var contactValue = from(e.data).firstOrDefault(c => c.ID === currContactID);

                if (!accentUtils.isNull(contactValue)) {
                    if (!accentUtils.isEmpty(contactValue.CompanyID) && contactValue.CompanyID !== viewModel.entity.CompanyID) {
                        viewModel.entity.CompanyID = contactValue.CompanyID;
                    }
                }
            }
        }

    }, [viewModel, cboCompany]);

    const onNewContactWizardCompleted = React.useCallback((e) => {
        if (!accentUtils.isEmpty(e.CompanyID)) {
            viewModel.entity.CompanyID = e.CompanyID;
        }
    }, [viewModel]);

    const onCompanyWizardCompleted = React.useCallback((e) => {
        if (!accentUtils.isEmpty(e.ContactID)) {
            viewModel.entity.ContactID = e.ContactID;
        }
    }, [viewModel]);

    const copyAddress = React.useCallback((query) => {
        query.then(function (address) {
            if (!accentUtils.isNull(siteAddressCtrl.current)) {
                siteAddressCtrl.current.copyAddressFrom(address);
            }
        });
    }, [siteAddressCtrl]);

    const copyCompanyAddress = React.useCallback((e) => {
        if (!accentUtils.isEmpty(viewModel.entity.CompanyID)) {
            copyAddress(query_AddressForCompany.getFirstOrDefault({ companyID: viewModel.entity.CompanyID }));   
        }

        e.promise();
    }, [viewModel, copyAddress]);

    const copyContactAddress = React.useCallback((e) => {
        if (!accentUtils.isEmpty(viewModel.entity.ContactID)) {
            copyAddress(query_AddressForContact.getFirstOrDefault({ contactID: viewModel.entity.ContactID }));               
        }

        e.promise();

    }, [viewModel, copyAddress]);

    const validateContact = React.useCallback((value) => {

        if (!ActivityService.Helper.activityRequiresContact(viewModel.entity)) {
            return undefined;
        }

        if (accentUtils.isEmpty(value))
            return { Msg: "Required", Type: "Error" };

        if (cboContact.current != null) {

            var combo = cboContact.current.getFormControl();
            var item = combo.getSelectedItem();

            if (!accentUtils.isNull(item)) {
                if (!accentUtils.isNull(item.ID)) {
                    if (!accentUtils.isEmpty(viewModel.entity.CompanyID)) {
                        if (item.CompanyID != viewModel.entity.CompanyID) {
                            return { Msg: "Contact does not match the Company", Type: "Error" };
                        }
                    }
                }
            }
        }

    }, [props, viewModel]);
    const validateDates = React.useCallback((e) => {

        var allDay = viewModel.entity.AllDay;
        var hasStart = !accentUtils.isNull(viewModel.entity.Start);
        var hasEnd = !accentUtils.isNull(viewModel.entity.End);

        if (allDay) {
            if (!hasStart) {
                return { Msg: "Start time is required", Type: "Error" };
            }
        } else {

            var isValid = viewModel.entity.Start < viewModel.entity.End;

            if (!isValid || !hasStart || !hasEnd) {
                return { Msg: "End time cannot be before the start time", Type: "Error" };
            }
        }
        return null;

    }, [viewModel]);

    const getOwnerID = React.useCallback(e => {
        return [viewModel.entity.RepresentativeID];
    }, [viewModel]);

    const getActivityCategoryQuery = React.useCallback(e => {
        return query_ActivityCategories.getAllAsQueryableWithCache({ includeID: viewModel.entity.PL_ActivityCategoryID, activeOnly: true });
    }, [viewModel]);


    const getCustomerAvailabilityQuery = React.useCallback(e => {
        return query_CustomerAvailability.getAllAsQueryableWithCache({ includeID: viewModel.entity.PL_CustomerAvailabilityID, activeOnly: true, activityType: viewModel.entity.ActivityType });
    }, [viewModel]);


    const getOppQuery = React.useCallback((e) => {
        return query_Opportunity_SelectList.getAllAsQueryableWithCache({ includeID: viewModel.entity.OpportunityID });
    }, [viewModel]);

    const getSalesRepQuery = React.useCallback((e) => {
        return query_ActivityAttendee_SelectList.getAllAsQueryableWithCache({ IncludeIDs: viewModel.entity.AttendeeList });
    }, [viewModel]);
    const getContactQuery = React.useCallback((e) => {
        return query_ActivityView_ContactSelectList.getAllAsQueryableWithCache({
            includeID: viewModel.entity.ContactID,
            companyID: viewModel.entity.CompanyID,
            opportunityID: viewModel.entity.OpportunityID,
            jobID: viewModel.entity.JobID
        });        
    }, [viewModel]);
    const getComanyQuery = React.useCallback((e) => {
        return query_Company_SelectList.getAllAsQueryableWithCache({ includeID: viewModel.entity.CompanyID });
    }, [viewModel]);

    const onShowInstallSummary = React.useCallback((e) => {

        showOK("", <ActivityInstallerViewCtrl contactID={contactID} address={address} jobLines={jobLines} jobID={viewModel.entity.JobID} printSettings={printSettings} />, []).then(r => {

            e.promise();
        });

    }, [viewModel]);

    const onHideInstallSummary = React.useCallback((e) => {
        setShowInstallSummary(false);
    }, [viewModel]);

    const onJobChanged = React.useCallback((e) => {
        viewModel.setDirty();

        // If the job changes (including being cleared), any selected job lines are no longer valid.
        const currJobID = viewModel.entity.JobID;
        const prevJobID = lastJobIDRef.current;
        if (prevJobID !== currJobID) {
            const existingJobLines = accentUtils.isEmpty(viewModel.entity.JobLines) ? [] : [...viewModel.entity.JobLines];
            existingJobLines.forEach(l => deleteEntity(l));
            lastJobIDRef.current = currJobID;
        }

        setForceUpdateKey(forceUpdateKey => forceUpdateKey + 1);

    }, [viewModel, setForceUpdateKey, forceUpdateKey]);


    const onUserChanged = React.useCallback((e) => {
        viewModel.entity.RepresentativeID = e.value;

        viewModel.timeZone = e.user?.timeZone;

        viewModel.setDirty();
        onOwnerChanged(e);
    }, [viewModel, onOwnerChanged]);

    const onTeamChanged = React.useCallback((e) => {
        viewModel.entity.TeamID = e.value;
        viewModel.setDirty();
    }, [viewModel]);

    const getShowContactDetails = React.useCallback((e) => {
        if (viewModel.entity.ActivityType === ActivityService.Helper.typeLeave)
            return false;
        else
            return true;
    }, [viewModel]);

    const onAddressChanged = (e) => {

    }
    

    
    React.useEffect(() => {
        if (viewModel == null) {

            if (accentUtils.isEmpty(props.activityID)) {

                clearEntities();

                addEntity("Activity", {}).then(newActivity => {


                    const currentUser = getUser();
                    let tz = props.timeZone;


                    if (props.onNew) {
                        props.onNew(newActivity);
                    }


                    if (!accentUtils.isNullOrEmpty(props.timeZone)) {
                        newActivity.Start = ConvertDateFromUTC(newActivity.Start, props.timeZone);
                        newActivity.End = ConvertDateFromUTC(newActivity.End, props.timeZone);
                    }

                    newActivity.AttendeeList = [];
                    if (newActivity.RepresentativeID) {
                        newActivity.AttendeeList = [newActivity.RepresentativeID];

                        if (currentUser.ID === newActivity.RepresentativeID) {
                            if (accentUtils.isNull(tz)) {
                                tz = currentUser.IANATimeZoneID;
                            }
                        }
                    }
                    
                    newActivity.DefaultProductList = [];
                    newActivity.DefaultJobLineList = [];

                    if (!accentUtils.isEmpty(newActivity.TagData)) {
                        var td = JSON.parse(newActivity.TagData);

                        if (!accentUtils.isEmpty(td.GroupKeys)) {
                            newActivity.DefaultProductList = td.GroupKeys;
                        }

                        if (!accentUtils.isEmpty(td.JobLineIDs)) {
                            newActivity.DefaultJobLineList = td.JobLineIDs;
                        }

                    }

                    setViewModel({
                        defaultUserTeam: { UserID: newActivity.RepresentativeID, TeamID: null },
                        entity: newActivity,
                        isNew: true,
                        timeZone: tz,
                        setDirty: function () { setIsDirty(true); }
                    });

                    setCanHaveJob(activityCanHaveJob( newActivity));

                    setAddressRequired(ActivityService.Helper.activityRequiresAddress(newActivity))

                }).catch(err => {
                    console.log(err);
                });
            } else {

                const done = showWait();

                query_Activity_View.getFirstOrDefault({ id: props.activityID }).then(r => {

                    const a = r.Activity;
                    const tz = props.timeZone ?? r.TimeZone;

                    if (!accentUtils.isNullOrEmpty(tz)) {
                        a.Start = ConvertDateFromUTC(a.Start, tz);
                        a.End = ConvertDateFromUTC(a.End, tz);
                    }

                    a.CancelledReasonDescription = r.CancelledReasonDescription ?? "";

                    a.AttendeeList = from(a.Attendees).select(i => i.RepID).toArray();
                    a.DefaultProductList = [];
                    a.DefaultJobLineList = [];
                    setViewModel({
                        defaultUserTeam: { UserID: a.RepresentativeID, TeamID: a.TeamID },
                        entity: a,
                        setDirty: function () { setIsDirty(true); },
                        isNew: false,
                        timeZone: tz,
                        contact: r.Contact,
                        opportunity: r.Opportunity,
                        company: r.Company,
                        category: r.ActivityCategory,
                        customerAvailability: r.CustomerAvailability
                    });

                    

                    setCanHaveJob(activityCanHaveJob(a));

                    setAttendeeReadOnly(accentUtils.isEmpty(a.RepresentativeID));
                    setAddressRequired(ActivityService.Helper.activityRequiresAddress(a))

                    setContext(contextSources.view, "Activity", props.activityID);

                    done();

                });
            }

        }
    }, []);


    React.useEffect(() => {

        if (viewModel == null) return;

        lastJobIDRef.current = viewModel.entity.JobID;

    }, [viewModel]);

    if (viewModel == null) {
        return <div />
    }

    var isReadOnly = (viewModel.entity.Status || ActivityStatus.Open) !== ActivityStatus.Open;
    var isJobLinesReadOnly = (viewModel.entity.Status || ActivityStatus.Open) !== ActivityStatus.Open || viewModel.entity.Processed;

    const allowEditJobOpp = !isReadOnly && (viewModel.isNew || (activityRequireJob(viewModel.entity) && accentUtils.isEmpty(viewModel.entity.JobID)));
    const showJobOpp = canHaveJob;

    viewModel.onNewContactWizardCompleted = onNewContactWizardCompleted;

    var subject = formHelper.getFieldCtrlModel(viewModel.entity, "Subject", "text", true, { label: "application_strings.entities.activity.Subject", readOnly: isReadOnly });
    var start = formHelper.getFieldCtrlModel(viewModel.entity, "Start", "datetime", validateDates, { label: "application_strings.entities.activity.Start", readOnly: isReadOnly || viewModel.entity.AllDay });
    var end = formHelper.getFieldCtrlModel(viewModel.entity, "End", "datetime", validateDates, { label: "application_strings.entities.activity.End", readOnly: isReadOnly || viewModel.entity.AllDay });
    var allDay = formHelper.getFieldCtrlModel(viewModel.entity, "AllDay", "check", false, { label: "application_strings.entities.activity.AllDay", readOnly: isReadOnly });
    var confirmedDay = formHelper.getFieldCtrlModel(viewModel.entity, "Confirmed", "check", false, { label: "application_strings.entities.activity.Confirmed", readOnly: isReadOnly });

    const autoScheduleLocked = formHelper.getFieldCtrlModel(viewModel.entity, "AutoScheduleLocked", "check", false, { label: "application_strings.entities.activity.AutoScheduleLocked", readOnly: isReadOnly });

    const customerAvailability = formHelper
        .getFieldCtrlModel(viewModel.entity, "PL_CustomerAvailabilityID", "select", false, { readOnly: isReadOnly, source: getCustomerAvailabilityQuery, sourceType: "PL_CustomerAvailability", defaultDisplayValue: viewModel.customerAvailability });


    var apptType = formHelper
        .getFieldCtrlModel(viewModel.entity, "ActivityType", "select", true, { label: "application_strings.entities.activity.ActivityType", readOnly: isReadOnly, abbreviateLabel: true, source: ActivityService.Helper.getActivityTypePicklistSource() });

    var apptPriority = formHelper
        .getFieldCtrlModel(viewModel.entity, "Priority", "select", false, { label: "application_strings.entities.activity.Priority", readOnly: isReadOnly, source: ActivityService.Helper.getActivityPriorityPicklistSource() });


    var apptCategory = formHelper
        .getFieldCtrlModel(viewModel.entity, "PL_ActivityCategoryID", "select", false, { readOnly: isReadOnly, abbreviateLabel: true, source: getActivityCategoryQuery, sourceType: "PL_ActivityCategory", defaultDisplayValue: viewModel.category });


    var notes = formHelper.getFieldCtrlModel(viewModel.entity, "Notes", "textArea", false, { readOnly: isReadOnly, placeHolder: "application_strings.views.calendar.notesPlaceHolder" });
    notes.field.options.rows = 4;

    var attendees = formHelper.getFieldCtrlModel(viewModel.entity, "AttendeeList", "multiSelect", true, { label: "application_strings.entities.activity.Attendees", readOnly: (isReadOnly || attendeeReadOnly), displayField: "FullName", source: getSalesRepQuery, sourceType: "Representative", multiSelectRequiredIDs: getOwnerID, onChange: onAttendeeChanged });

    var opp = !showJobOpp ? null :
        formHelper.getFieldCtrlModel(viewModel.entity, "OpportunityID", "select", false, { label: "application_strings.entities.activities.OpportunityID", readOnly: !allowEditJobOpp, displayField: "Description", labelLink: "Opportunity", source: getOppQuery, sourceType: "Opportunity", defaultDisplayValue: viewModel.opportunity });

    var company = formHelper
        .getFieldCtrlModel(viewModel.entity, "CompanyID", "select", false, { label: "application_strings.entities.activity.Company", readOnly: isReadOnly, labelLink: "Company", displayField: "Name", source: getComanyQuery, sourceType: "Company", defaultDisplayValue: viewModel.company });

    var contact = formHelper
        .getFieldCtrlModel(viewModel.entity, "ContactID", "select", validateContact, { label: "application_strings.entities.activity.Contact", readOnly: isReadOnly, labelLink: "Contact", displayField: "FullName", source: getContactQuery, sourceType: "Contact", onDataRecieved: onContactDataReceived, defaultDisplayValue: viewModel.contact });

    start.field.options.onChange = function (e) {
        shiftEndWithStartChange(viewModel.entity, e);
    };

    allDay.field.options.onChange = function (e) {
        setForceUpdateDatesKey(x => x + 1);
    };

    apptType.field.options.onChange = function (e) {        
        setCanHaveJob(activityCanHaveJob(viewModel.entity));

        setAddressRequired(ActivityService.Helper.activityRequiresAddress(viewModel.entity));

        cboContact.current.refresh();
    };


    company.field.options.comboAddNewValue = v => onSelectAddCompany({
        value: v,
        done: onCompanyWizardCompleted,
        contactID: viewModel.entity.ContactID,
    });


    company.field.options.onChange = function (e) {
        if (e.newValue) {
            cboContact.current.refreshData();
        } else {
            viewModel.entity.ContactID = null;
            cboContact.current.clearValue();
            cboContact.current.refreshData();
        }
    };

    contact.field.options.comboAddNewValue = v => onSelectAddContact({
        value: v,
        done: onNewContactWizardCompleted,
        companyID: viewModel.entity.CompanyID,
    });
    contact.field.options.onChange = function (e) {
        if (e.newValue) {
            cboCompany.current.getFormControl().selectValue(viewModel.entity.CompanyID);
        }

    };


    end.field.options.onChange = function (e) {
        
    };
    const isNew = accentUtils.isEmpty(viewModel.entity.ID) || viewModel.entity.ID < 0;
    const isPlanning = !isNew && viewModel?.entity?.IsPlanning === true;
    var allowDelete = !isNew && !isReadOnly;



    var showNewServiceJob = !isNew && !isPlanning && getAccess().modules().RTL_Service() && (viewModel.entity.ActivityType == ActivityService.Helper.typeInstall || viewModel.entity.ActivityType == ActivityService.Helper.typeRework || viewModel.entity.ActivityType == ActivityService.Helper.typeService || viewModel.entity.ActivityType == ActivityService.Helper.typeWarranty);
    var showNewQuote = !isPlanning && (viewModel.entity.ActivityType == ActivityService.Helper.typeSales || viewModel.entity.ActivityType == ActivityService.Helper.typeShowroomQuote) && !(isReadOnly || !validation.isValid);
    var showReOpen = !isNew && !isPlanning && viewModel.entity.Status === ActivityStatus.Closed
    var showUncancel = !isNew && !isPlanning && viewModel.entity.Status == ActivityStatus.Cancelled
    var showComplete = !isNew && !isPlanning && !isReadOnly; // && viewModel.entity.ActivityType !== ActivityService.Helper.typeCheckMeasure;
    var showCancel = !isNew && !isPlanning && !isReadOnly && viewModel.entity.Status !== ActivityStatus.Cancelled
    var showStartCM = !isNew && !isPlanning && viewModel.entity.Status === ActivityStatus.Open && viewModel.entity.ActivityType === ActivityService.Helper.typeCheckMeasure;

    var showOutcomes = viewModel.entity.Status === ActivityStatus.Closed && (viewModel.entity.ActivityType === ActivityService.Helper.typeInstall || viewModel.entity.ActivityType === ActivityService.Helper.typeCheckMeasure);

    const jobAndLinesRequired = activityRequireJob(viewModel.entity) && !accentUtils.isNull(viewModel.entity.JobID);

    var showContDetails = getShowContactDetails();
    const requireAddress = addressRequired;

    var addressButtons = [
        (<AccentButton tagName="calCopyCompanyBtn" disabled={isReadOnly} bsStyle="primary" onClick={copyCompanyAddress}>
            <AccentIcons.Company top="4" />
            {t("application_strings.application.buttons.copyAddress")}
        </AccentButton>),
        (<AccentButton tagName="calCopyContactBtn" disabled={isReadOnly} bsStyle="primary" onClick={copyContactAddress}>
            <AccentIcons.Contact top="4" />
            {t("application_strings.application.buttons.copyAddress")}
        </AccentButton>)
    ];
    var jobLines = viewModel.entity.JobLines;

    
    const contactInfo = accentUtils.isEmpty(viewModel.entity.ContactID) ? null :
        <ContactInfoCtrl
            isLarge
            style={{ display: 'inline-block' }}
            id={viewModel.entity.ContactID}
            JobID={viewModel.entity.JobID}
            ActivityID={viewModel.entity.id}
            OpportunityID={viewModel.entity.OpportunityID} />;

    var address = siteAddressCtrl.current ? siteAddressCtrl.current.getAddress() : viewModel.entity.Address;
    var contactID = viewModel ? viewModel.entity.ContactID : null;

    const timeZoneDisplay = accentUtils.isNullOrEmpty(viewModel.timeZone) ? null : <span style={{ fontSize: "small", fontStyle: "italic", opacity: 0.5, display: "inline-block", padding: "10px 0px 0px 10px" }}>({(isMobileOnly ? "tz" : "Time zone")}:{viewModel.timeZone})</span>;

    const liveDiary = viewModel.entity.LiveDiary ? <AccentIcons.LiveDiary noPadding top={-2} style={{ display: "inline-block", paddingLeft: "5px" }} /> : null;

    const fileNoteAlerts = !accentUtils.isEmpty(viewModel.entity.ContactID) && <FileNoteAlert top={-3} contactID={viewModel.entity.ContactID} />;

    const cancellationDetailsContent = viewModel.entity.Cancelled && (() => {
        const entity = viewModel.entity;
        const details = {
            Reason: getCancelledReasonText(entity),
            By: entity.CancelledBy || "",
            Notes: entity.CancelledNotes || ""
        };

        const fieldConfigs = [
            { label: t("application_strings.application.dialogs.activityCancelDlg.cancelledReasonLabel"), fieldName: "Reason", type: "text" },
            { label: t("application_strings.application.dialogs.activityCancelDlg.cancelledByLabel"), fieldName: "By", type: "text" },
            { label: t("application_strings.application.dialogs.activityCancelDlg.cancelledNotesLabel"), fieldName: "Notes", type: "textArea", rows: 3 }
        ].filter(c => !accentUtils.isEmpty(details[c.fieldName]));

        const renderField = (c) => {
            const model = formHelper.getFieldCtrlModel(details, c.fieldName, c.type, false, { label: c.label, readOnly: true });
            if (c.rows) model.field.options.rows = c.rows;
            return <Row key={c.fieldName}><Col md={12}><AccentFormCtrlNoViewState model={model} /></Col></Row>;
        };

        const body = fieldConfigs.length > 0 ? fieldConfigs.map(renderField) : 
        <Row>
            <Col md={12}>
                <div className="mb-2">{t("application_strings.application.dialogs.activityCancelDlg.cancelledNoDetails")}</div>
            </Col>
        </Row>;

        return (
            <>
                <div className="acc-hr">Cancellation Details</div>
                <Row><Col md={12}>{body}</Col></Row>
            </>
        );
    })();

    const headerContent = <React.Fragment >
        <div >{fileNoteAlerts}</div>
        {!isNew && <ActivitySummaryIcon id={viewModel.entity.ID} top={-3} onBeforePrint={onBeforePrint} />}
        <div className="me-auto" ><h5>{t("application_strings.views.calendar.appointment")}{timeZoneDisplay}{liveDiary}</h5></div>        
        <AccentDropdownButton tagName="calendarActions" title={t("application_strings.application.buttons.actions")}>
            <DropdownMenu>
                {!showNewQuote ? null :
                    (
                        <DropdownItem onClick={newQuote}>
                            {t("application_strings.application.buttons.newQuote")}
                        </DropdownItem>
                    )}
                {!showNewServiceJob ? null :
                    (
                        <DropdownItem onClick={newServiceJob}>
                            {t("application_strings.application.buttons.newServiceJob")}
                        </DropdownItem>
                    )}
                {!showNewQuote && !showNewServiceJob ? null :
                    (
                        <DropdownItem divider />
                    )}
                {!showStartCM ? null :
                    <DropdownItem disabled={!getAccess().features().FeatureAllowPerformCheckMeasure()} onClick={startCM}>
                        {t("application_strings.application.buttons.startCM")}
                    </DropdownItem>
                }
                {isPlanning ?
                    <>
                        <DropdownItem disabled={isReadOnly} onClick={setLive}>
                            Set Live
                        </DropdownItem>
                        <DropdownItem divider />
                    </>
                    : null}
                {!showComplete ? null :
                    <DropdownItem onClick={closeActivity}>
                        {t("application_strings.application.buttons.completeAppointment")}
                    </DropdownItem>
                }
                {!showReOpen ? null :
                    <DropdownItem onClick={openActivity}>
                        {t("application_strings.application.buttons.reOpenAppointment")}
                    </DropdownItem>
                }
                {!showUncancel ? null :
                    <DropdownItem onClick={uncancelActivity}>
                        {t("application_strings.application.buttons.uncancelAppointment")}
                    </DropdownItem>
                }
                {!showCancel ? null :
                    <DropdownItem onClick={cancelActivity}>
                        {t("application_strings.application.buttons.cancelAppointment")}
                    </DropdownItem>
                }
                {isMobileOnly || isNew || !(getAccess().features().FeatureAllowManagement() || getAccess().features().FeatureAllowSetup()) ? null : <>
                    <DropdownItem divider />
                    <DropdownItem onClick={e=> showHistory(1)}>
                        {`${t("application_strings.application.buttons.auditLog")} Activity`}
                    </DropdownItem>
                    <DropdownItem onClick={e => showHistory(2)}>
                        {`${t("application_strings.application.buttons.auditLog")} Attendees`}
                    </DropdownItem>
                    <DropdownItem onClick={e => showHistory(3)}>
                        {`${t("application_strings.application.buttons.auditLog")} Lines`}
                    </DropdownItem>
                    </>                    
                }
            </DropdownMenu>
        </AccentDropdownButton>
    </React.Fragment>;


    const actionsContent = [        
        <AccentButton key="2" tagName="calCloseAndShowBtn" disabled={isReadOnly || !validation.isValid} onClick={(e) => saveActivity(e, true)}>
            <AccentDisplay large tablet>
                {t("application_strings.application.buttons.save")} and show in <AccentIcons.Calendar style={{ marginTop: "-10px" }} top="5" />
            </AccentDisplay>
            <AccentDisplay mobile>
                <AccentIcons.Calendar top="4" />
            </AccentDisplay>
        </AccentButton>,
        <AccentButton key="3" tagName="calCloseBtn" disabled={isReadOnly || !validation.isValid} onClick={(e) => saveActivity(e, false)}>
            <AccentDisplay large tablet>
                {t("application_strings.application.buttons.save")} and Close
            </AccentDisplay>
            <AccentDisplay mobile>
                <AccentIcons.Save top="4" />
            </AccentDisplay>
        </AccentButton>
    ];

    if (isMobileOnly && (user.ID === viewModel?.entity?.RepresentativeID || viewModel?.entity?.AttendeeList?.includes(user.ID))) {
        actionsContent.unshift(<AccentButton key="2" tagName="viewRun" onClick={(e) => showRunDlg(e)}>
                <AccentIcons.Info top="4" />
        </AccentButton>)
    }

    return (
        <div>
            <AccentDialog                
                id="accentCalendarDlg"
                className="accentCalendarDlg"
                fullscreen
                onClose={cancelDlg }
                headerContent={headerContent}
                actionsContent={actionsContent}
            >
                    <Row>
                        <Col md={12}>
                            <div className="activity-dlg-cancelled-banner">
                                <RTLReadOnlyBar readOnly={viewModel.entity.Cancelled} msg="activity_cancelled" />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <AccentFormCtrlNoViewState model={apptType} />
                            <AccentFormCtrlNoViewState model={apptCategory} />
                            <AccentFormCtrlNoViewState model={subject} />
                            <UserTeamSelectCtrl defaultValue={viewModel.defaultUserTeam} onTeamChange={onTeamChanged} onUserChange={onUserChanged} tagName="activityUserTeam" readOnly={isReadOnly} />

                            <AccentFormCtrlNoViewState key={`att${attendeeReadOnly}`} ref={ctrlAttendees} model={attendees} />
                        </Col>
                        <Col md={6}>
                            <AccentFormCtrlNoViewState model={apptPriority} />
                            <AccentFormCtrlNoViewState key={`start_${forceUpdateDatesKey}`} model={start} />
                            <AccentFormCtrlNoViewState key={`end_${forceUpdateDatesKey}`} model={end} />
                            <AccentFormCtrlNoViewState model={allDay} />
                            {!showJobOpp ? null : <div className='row'>
                                <div className="col-12">
                                    <ActivityJobCtrl
                                        viewModel={viewModel}
                                        onChange={onJobChanged}
                                        readOnly={!allowEditJobOpp}
                                        required={jobAndLinesRequired}
                                        post={[<AccentButton onClick={onShowInstallSummary}><AccentIcons.Eye top="3" style={{ fontSize: "18px"} } /></AccentButton>]  }
                                    />
                                </div>
                            </div>}
                            {!showJobOpp ? null : <AccentFormCtrlNoViewState model={opp} />}
                        </Col>
                    </Row>
                    {!showContDetails ? null :
                        <React.Fragment>                                                        
                            <Row>
                                <Col md={6} xs={12}>
                                    <div className="acc-hr">Contact Details</div>
                                    <Row>
                                        <Col md={12} xs={12}>
                                            <AccentFormCtrlNoViewState ref={cboCompany} model={company} post={[display.mobile ? null : addressButtons[0]] } />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <AccentFormCtrlNoViewState
                                                ref={cboContact}
                                                model={contact}
                                                post={[contactInfo,  display.mobile? null : addressButtons[1]]} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                        <AccentFormCtrlNoViewState model={customerAvailability} />
                                        <div className="d-flex gap-2">
                                            <div><AccentFormCtrlNoViewState model={confirmedDay} /></div>
                                            <div><AccentFormCtrlNoViewState model={autoScheduleLocked} /></div>
                                        </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={12}>
                                            <ActivityJobLineCtrl key={forceUpdateKey} viewModel={viewModel} readOnly={isJobLinesReadOnly} required={jobAndLinesRequired} />
                                        </Col>
                                    </Row>
                                </Col>
                                <AccentDisplay large tablet>
                                    <Col md={6}>
                                        <div className="acc-hr">Address Details</div>
                                        <AccentAddress ref={siteAddressCtrl} entity={viewModel.entity} addressMember="Address" readOnly={isReadOnly} onChange={onAddressChanged} required={requireAddress} />
                                    </Col>
                                </AccentDisplay>
                            </Row>                            
                        </React.Fragment>
                    }
                    <AccentDisplay mobile>
                        <div className="acc-hr">Address Details</div>
                        <div className="d-flex justify-content-between">
                            <div className="pt-2 pb-2">
                                {addressButtons[0]}
                            </div>
                            <div className="pt-2 pb-2 pe-4">
                                {addressButtons[1]}
                            </div>
                        </div>
                        <AccentAddress ref={siteAddressCtrl} entity={viewModel.entity} addressMember="Address" readOnly={isReadOnly} onChange={onAddressChanged} required={requireAddress} />
                    </AccentDisplay>
                    <div className="acc-hr">Notes</div>
                    <Row>
                        <Col md={12}>
                            <Row><Col md={12}><AccentFormCtrlNoViewState id="act-notes" noLabel model={notes} /></Col></Row>
                        </Col>
                    </Row>
                    {cancellationDetailsContent}
                {showOutcomes && <div className="acc-hr">Outcomes</div>}
                {showOutcomes && <ActivityOutcomeCtrl activityID={viewModel.entity.ID} />}
            </AccentDialog>

        </div>
    );

}));
